import initialState from './initialState'
import {
    FETCH_SAVE_SHOPPING_LIST_REQUEST,
    FETCH_SAVE_SHOPPING_LIST_SUCCESS,
    FETCH_SAVE_SHOPPING_LIST_ERROR
} from '../constants/actionTypes'


export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SAVE_SHOPPING_LIST_REQUEST:
            return {
                ...state,
                isLoading: true
            }

        case FETCH_SAVE_SHOPPING_LIST_SUCCESS:
        case FETCH_SAVE_SHOPPING_LIST_ERROR:
            return {
                ...state,
                isLoading: false,
            }

        default:
            return state
    }
}
